module.exports = __webpack_public_path__ + "img/p14.a71c57f5.png";